export enum DocumentResultType {
  Letter = "letter",
  Document = "document",
  InboundFax = "inbound_fax",
}

export const DOCUMENT_METHOD_LABEL = {
  fax: "Fax",
  provider_portal: "Provider Portal",
  emr: "EMR",
  email: "Email",
  mail: "Mail",
  external_vendor: "External Vendor",
} as const;

export type DocumentMethod = keyof typeof DOCUMENT_METHOD_LABEL;
